import SystemSettingActionType from 'actions/systemSetting/systemSettingActionType';

export const getSystemSettings = () => ({
  type: SystemSettingActionType.GET_SYSTEM_SETTINGS,
});

export const saveSystemSettings = (data) => ({
  type: SystemSettingActionType.SAVE_SYSTEM_SETTINGS,
  payload: { data },
});

export const resetSystemSettings = () => ({
  type: SystemSettingActionType.RESET_SYSTEM_SETTINGS,
});

export const editSystemSettings = (data) => ({
  type: SystemSettingActionType.EDIT_SYSTEM_SETTINGS,
  payload: { data },
});
